import { useCallback, useState } from 'react'

import { SiderCollapsedStorage } from '../-models'

type UseSiderCollapsed = {
  collapsed: boolean
  toggle: () => void
}

/**
 * サイドバーの開閉状態を管理するカスタムフック
 */
export const useSiderCollapsed = (): UseSiderCollapsed => {
  const [collapsed, setCollapsed] = useState<boolean>(
    SiderCollapsedStorage.getItem()
  )

  const toggle = useCallback(() => {
    setCollapsed((collapsed) => {
      const newValue = !collapsed
      SiderCollapsedStorage.setItem(newValue)
      return newValue
    })
  }, [setCollapsed])

  return {
    collapsed,
    toggle
  }
}
